import type { ResourcesConfig } from 'aws-amplify';

import { AWS_CONFIG } from '../config/aws';

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: AWS_CONFIG.cognito.userPoolId,
      userPoolClientId: AWS_CONFIG.cognito.userPoolClientId,
      loginWith: {
        oauth: {
          domain: AWS_CONFIG.cognito.managedLoginDomain,
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [AWS_CONFIG.cognito.redirectSignIn],
          redirectSignOut: [AWS_CONFIG.cognito.redirectSignOut],
          responseType: 'code',
        },
      },
    },
  },
  API: {
    GraphQL: {
      endpoint: AWS_CONFIG.graphql.endpoint,
      region: AWS_CONFIG.region,
      defaultAuthMode: 'userPool',
    },
  },
};
